import { t } from "./types";
import type { z } from "zod";

export const PaymentConfigurationSchema = t.object({
  paymentProvider: t.enum(["Stripe", "None"]),
  usesFixedPricing: t.boolean(),
});

export type PaymentConfiguration = z.infer<typeof PaymentConfigurationSchema>;

export function usesStripePayments(school: { paymentConfiguration?: PaymentConfiguration } | undefined): boolean {
  // Wait for the school to load, but preserve legacy behavior until configuration is backfilled.
  return !!school && school.paymentConfiguration?.paymentProvider !== "None";
}

export function canViewPayoutOverview(
  school: { paymentConfiguration?: PaymentConfiguration } | undefined,
  publishedPayoutCount: number | undefined,
): boolean {
  return !!school && (usesStripePayments(school) || (publishedPayoutCount ?? 0) > 0);
}
